import { Roles } from "features/panelManagement/accessManagement/types/access";

export interface NavbarDefinition {
    titleText: string;
    logoutText: string;
    menuItems: string[]; // representing top-level menu item accessors
}

export interface NavbarMenuItem {
    accessor: string; // format {parent}: ... :{child}
    displayText: string;
    displayIcon?: NavbarDisplayIcon;
    route?: string;
    rolesPermitted?: Roles[];
}

export enum NavbarDisplayIcon {
    Tag = "Tag",
    Category = "Category",
    Supplier = "Supplier",
    Process = "Process",
    Application = "Application",
    Custom = "Custom",
    Product = "Product",
    News = "News",
    Article = "Article",
    Dashboard = "Dashboard",
    Analytics = "Analytics",
    Deployments = "Deployments",
    PanelManagement = "PanelManagement",
    Access = "Access",
    Logs = "Logs",
    Backups = "Backups",
}
